// import ncap from '@/capturn/niuniucapture.js'
var captureObj = null;
var cap_vue = null
var downloadUrl = 'static/CaptureInstall.exe?';
function ShowDownLoad(self){
	self.ShowDownLoad('截图如果超过5秒无响应，请点此<a target="_blank" href="' + downloadUrl + '" + date.getMinutes() + date.getSeconds()">安装</a>')
}
function VersionCallback(ver){}
function PluginLoadedCallback(success){
	console.info("截图插件初始化完成。")
    if(success){
		console.info("截图插件初始化完成。")
    }
}
function Init(self)
{
	cap_vue = self;
	if(isMacintosh()){
		downloadUrl = 'static/CaptureInstall.dmg?';
	}
    captureObj = new NiuniuCaptureObject();
    captureObj.NiuniuAuthKey = "niuniu";
    captureObj.TrackColor = rgb2value(255, 0, 0);  //此处可以设置相关参数 
    captureObj.EditBorderColor = rgb2value(0, 0, 255);
    function OnCaptureFinishedCallback(type, x, y, width, height, info, content,localpath) 
    {
        if(type < 0){
            ShowDownLoad(self);//需要重新安装控件
            return;
        }
		if(type == 1){
			var base64img = "data:image/png;base64," + content;
			var imghtml='<img src="'+base64img+'" style="max-width:100%;">';
			self.setAppendContent(imghtml);
		}else{
			console.log(type)
			switch (type){
				case 2:
					console.info("您取消了截图")
					break;
				case 3:
					console.info("您保存了截图到本地");
			}
		}
    }
    //设置控件加载完成以及截图完成的回调函数
    captureObj.FinishedCallback = OnCaptureFinishedCallback;
    captureObj.PluginLoadedCallback = PluginLoadedCallback;
	captureObj.VersionCallback = VersionCallback;
    captureObj.InitNiuniuCapture(); //初始化控件 
}

function StartCapture(hideFlag,self){
    var captureRet = Capture(hideFlag);
	console.info("captureRet"+captureRet)
    if(captureRet == emCaptureFailed)
    {	
		ShowDownLoad(self);
		return;
		console.error("启动失败")
        //ShowDownLoad();
    }
	else if(captureRet == emCaptureUnknown){
		console.info("无响应")
		ShowDownLoad(self);
		return;
		//$('#info').html('正在截图中, 如果超过5秒无响应，请点此<a target="_blank" style="font-size: 20px; line-height: 30px; color: rgb(211, 30, 26);" href="' + downloadUrl + '" + date.getMinutes() + date.getSeconds()">安装</a>');
	}
}
function Capture(hideFlag) {
	hideFlag = hideFlag ? 1 : 0; 
    var defaultName = "1.jpg";
    var captureRet = true;
    return captureObj.DoCapture("1.jpg", hideFlag, 0, 0, 0, 0, 0);
}
export default{
	Init,
	StartCapture
}